<template>
<section class="button-row px-4 py-5%">
    <SmoothLoader class="max-w-4xl mx-auto">
        <div class="grid" :class="`columns-${cols}`">
            <div v-for="button in buttons" class="text-center">
                <Button :url="button.url" :label="button.label" class="items-center h-full"></Button>
            </div>
        </div>
    </SmoothLoader>
</section>
</template>

<script>
import { computed } from 'vue';

export default {

    props: ['data'],
    
    setup(props) {

        const cols = computed(() => {

            let count = props.data.buttons.length;
            if (count == 1) {
                return 1;
            }
            if (count % 3 === 0) {
                return 3;
            }
            return 2;
        });

        return {
            ...props.data,
            cols
        }
    }

}
</script>